import React, { useState, useEffect } from "react";

import styles from "../index.module.css";

function ActivePlayerItem(props) {
  const {
    player: { screenName, maxNumBets, numBets, score, bestScore, scoreDate }
  } = props;

  const [activated, setActivated] = useState(false);
  const now = new Date();
  const isNew =
    (Date.parse(now.toUTCString()) - Date.parse(scoreDate)) / 1000 < 10;

  const formattedNumBets =
    maxNumBets === 99999 ? numBets : (maxNumBets || 0) - (numBets || 0);

  useEffect(() => {
    if (isNew) {
      setActivated(true);
    } else {
      setActivated(false);
    }
  }, [isNew, formattedNumBets]);

  return (
    <div
      className={`${styles.activeplayersItem} ${
        activated ? styles.activeBorder : null
      }`}
    >
      <div className={styles.activeplayersName}>{screenName}</div>
      <div className={styles.activeplayersHighscore}>{bestScore}</div>
      {formattedNumBets > 0 ? (
        <div className={styles.activeplayersSpin}>{formattedNumBets}</div>
      ) : null}

      <div className={`${styles.activeplayersScore}`}>{score}</div>
    </div>
  );
}
export default ActivePlayerItem;
